import * as v from "valibot";
import { BaseRecordSchema, baseVals, defineValidation } from "../../common/validation.common";
import { CapacityUnitEnum } from "../../data/enums";

export namespace NetworkPOPValidation {
    export const Record = defineValidation(BaseRecordSchema);

    export const Create = defineValidation(
        v.object({
            name: baseVals.string(),
            location: baseVals.coordinate(),
            radius: v.number(),
            capacity: v.number(),
            capacityUnit: v.picklist(CapacityUnitEnum.values),
            picName: baseVals.string(),
            picContact: baseVals.string(),
        }),
    );

    export const Update = defineValidation(
        v.object({
            name: v.exactOptional(baseVals.string()),
            location: v.exactOptional(baseVals.coordinate()),
            radius: v.exactOptional(v.number()),
            capacity: v.exactOptional(v.number()),
            capacityUnit: v.exactOptional(v.picklist(CapacityUnitEnum.values)),
            picName: v.exactOptional(baseVals.string()),
            picContact: v.exactOptional(baseVals.string()),
        }),
    );

    export const Coords = defineValidation(
        v.object({
            lat: v.number(),
            lng: v.number(),
            radius: v.number(),
        }),
    );
}
